export default class GA4Tracking {

  static pushEvent(event, items, ecommerceData) {
    this.clearDataLayer()

    items = items.map(item => this.createItem(item))

    let value = items.map(item => (item.price - item.discount) * item.quantity).reduce((a,b) => a+b, 0)

    let data = {
      'event': 'ga4_' + event,
      'ecommerce': {
        'items': items,
        'currency': 'DKK',
        'value': value
      }
    }

    if(typeof ecommerceData === 'object') {
      Object.assign(data.ecommerce, ecommerceData)
    }

    window.dataLayer.push(data)
  }

  static clearDataLayer() {
    if (window.dataLayer === undefined) {
      window.dataLayer = []
    }

    window.dataLayer.push({
      'ecommerce': null
    });
  }

  static getItemsFromModules(modules) {
    return modules.map(module => module.ga4_tracking_item)
  }

  static getItemsFromCartEventGroups(eventGroups) {
    return eventGroups.map((eventGroup, index) => {
      let participantCount = eventGroup.participantCount ?? eventGroup.quantity
      participantCount = participantCount === undefined ? 1 : participantCount
      let data = {
        'price': eventGroup.pricePerParticipant ?? eventGroup.price,
        'discount': eventGroup.totalDiscount / participantCount,
        'quantity': participantCount,
        'index': index,
      }
      return Object.assign(eventGroup.ga4_tracking_item, data)
    });
  }

  static createItem(data) {
    let defaultData = {
      'item_id': null,
      'item_name': null,
      'affiliation': null,
      'coupon': null,
      'currency': 'DKK',
      'discount': 0,
      'index': null,
      'item_brand': 'Seminarer.dk',
      'item_category': null,
      'item_variant': null,
      'location_id': null,
      'price': 0,
      'quantity': 1
    }

    return Object.assign(defaultData, data)
  }


  // HELPER FUNCTIONS
  static handleUpdateOfProductsInCart (items, oldParticipantsCount, newParticipantsCount) {
    let quantity = oldParticipantsCount < newParticipantsCount
      ? newParticipantsCount - oldParticipantsCount
      : oldParticipantsCount - newParticipantsCount

    if (oldParticipantsCount === newParticipantsCount) {
      return
    }

    let _event = oldParticipantsCount < newParticipantsCount ? 'add_to_cart' : 'remove_from_cart'
    let _items = items
    _items = _items.map(item => {
      item.quantity = quantity
      return item
    })

    // Google Analytics (GA4)
    GA4Tracking.pushEvent(_event, _items)
  }

  static handleUpdateOfAddonsInCart (addon, participantsCount, event = 'add_to_cart') {
    let _addon = addon
    _addon.ga4_tracking_item.quantity = participantsCount

    // Google Analytics (GA4)
    GA4Tracking.pushEvent(
      event,
      [_addon.ga4_tracking_item]
    )
  }

  static getItemsAndAddonsFromCartEventGroups(eventGroups) {
    let _eventGroups = []

    eventGroups.forEach(eventGroup => {
      let participantsCount = Object.keys(eventGroup.participants).length
      _eventGroups.push(eventGroup)

      let _addons = eventGroup.addons !== undefined ? eventGroup.addons : eventGroup.chosen_addons
      if (_addons !== undefined) {
        _addons.forEach(addon => {
          if (eventGroup.hasAddon(addon)) {
            let _addon = addon
            _addon.quantity = participantsCount
            _eventGroups.push(_addon)
          }
        })
      }
    })

    return this.getItemsFromCartEventGroups(_eventGroups)
  }

}